import { addLocaleData, InjectedIntl, IntlProvider } from 'react-intl';

import { Injectable } from 'injection-js';
import * as enLangSupport from 'react-intl/locale-data/en';
// import translations
import messages_en from '../translations/messages-en';

@Injectable()
export class IntlService {
	private localLn = 'en'; // for now only 'en' is supported.
	private messages = {
		en: messages_en,
	};
	private intl: InjectedIntl;

	constructor() {
		// This is to setup and get reference of intl object that will be used when translations/formatting are to be
		// access through 'react-intl' api.
		const intlProvider = new IntlProvider({
			locale: this.localLn,
			messages: this.messages[this.localLn],
		});
		this.intl = intlProvider.getChildContext().intl;

		// This is tell 'react-intl' that we need translation & formatting support for the specified language(s)
		addLocaleData([...enLangSupport]);
	}

	// This method is available to provide translation message to IntlProvider only and should not be used directly.
	public GetMessagesIntlProvider = (localLang: string) => {
		return this.messages[localLang];
	};

	// Returns Translation Message for given messageId. This data comes from the translation files
	public GetFormattedMessage = (
		messageId: string,
		values?: {
			[key: string]: ReactIntl.MessageValue;
		}
	) => {
		return this.intl.formatMessage({ id: messageId }, values);
	};
}



// WEBPACK FOOTER //
// ./src/services/intl.service.ts